import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import Fetch from "components/Fetch";
import colors from "constants/palette";

export default function Categories({ setData, oldData, handleCancel, reload }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);

  const onSubmit = (data) => {
    const submitData = {
      ...data,
      data: JSON.stringify({}),
      notifications: JSON.stringify([]),
    };
    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/users", submitData, (res) => {
        console.log("new users response", res);
        if (res.success) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          reload();
        } else {
          if (
            res?.message.phone ||
            res?.message.confirm_password ||
            res?.message.password
          ) {
            res?.message.phone && message.error(res?.message.phone[0]);
            res?.message.confirm_password &&
              message.error(res?.message.confirm_password[0]);
            res?.message.password && message.error(res?.message.password[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/users/${oldData.id}`, submitData, (res) => {
        console.log("new category response/UPDATE", res);
        if (res.success) {
          message.success("با موفقیت آپدیت شد");

          reload();

          handleCancel();
          cleanForm();
        } else {
          message.error(res.message.phone[0]);
        }
      });
    }
    setLoading(false);
  };

  function cleanForm() {
    form.resetFields();
  }
  if (oldData) {
    form.setFieldsValue(oldData);
  }

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ direction: "rtl" }}
      name={oldData ? "update" : "new"}
      onFinish={onSubmit}
    >
      <Label>نام کاربر :</Label>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: "لطفا نام کاربر را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Label>تلفن :</Label>
      <Form.Item
        name="phone"
        rules={[
          {
            required: true,
            message: "لطفا تلفن را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Label>آدرس :</Label>
      <Form.Item
        name="address"
        rules={[
          {
            required: true,
            message: "لطفا آدرس را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Label>کلمه عبور{oldData && " جدید"} :</Label>
      <Form.Item
        name="password"
        rules={[
          {
            required: oldData ? false : true,
            message: "لطفا کلمه عبور را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      {!oldData && (
        <React.Fragment>
          <Label>تکرار کلمه عبور :</Label>
          <Form.Item
            name="confirm_password"
            rules={[
              {
                required: true,
                message: "لطفا تکرار کلمه عبور را وارد کنید!",
              },
            ]}
          >
            <Input size="large" placeholder="" />
          </Form.Item>
        </React.Fragment>
      )}
      <Button
        loading={loading}
        htmlType="submit"
        style={{ width: "100%", marginTop: 16 }}
      >
        {oldData ? (
          "اصلاح"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            اضافه کردن
          </span>
        )}
      </Button>
    </Form>
  );
}

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
